module.exports = new __parcel__URL__("disconnect_button_disabled.9f461877.png").toString();